module.exports = __webpack_public_path__ + "static/media/hall-PC.b517ab2e.svg";